import React, { useEffect, useMemo, useState } from 'react';
import ReportGijgoGrid from '../../internal/ReportsScreens/GijgoForReportsScreen';
import formatters from '../../../Core/Grid/inputFormatter';
import { SquareButton } from '../../../Core/FormInput/AppButton';
import { Grid } from '@material-ui/core';
import BreadCrumbs from '../../../Core/Controls/Breadcrumb';
import ReactDOM from 'react-dom';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';

import AddEditVmrsModal from './addEditVmrsSubCategoryModal';
import DialogComp from '../../../Core/Modal/dialogModal';

const modalgridStyle = {
    formatterImageContainer: { width: '100%', textAlign: 'center' },
    formatterImage: { width: 90, height: 'auto', backgroundSize: 'cover' },
    formatterEditBtn: { textAlign: 'center' }
};
const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'VMRS Sub Categories', active: true }
];

const base_columns = [
    { field: 'action', title: 'Action', width: '5%' },
    { field: 'vmrsSubCategoryDescription', title: 'Description', width: '25%' },
    { field: 'vmrsDescription', title: 'VMRS Category', width: '20%' },
    { field: 'vmrsSubCategoryInternalRate', title: 'Internal Rate', align: 'right', width: '15%' },
    { field: 'vmrsSubCategoryRechargeRate', title: 'Recharge Rate', align: 'right', width: '15%' },
    { field: 'vmrsSubCategoryFixedCost', title: 'Fixed Cost?', width: '10%' },
    {
        field: 'vmrsSubCategoryNominalCode',
        title: 'Nominal Code',
        width: '15%'
    }
];

const VmrsSubCategoryScreen = () => {
    const [state, setState] = useState({ modalToggle: false, subCategoryId: null, List: [], showLoader: true });

    const pullVmrsSubCategory = () => {
        setState((st) => ({ ...st, isReload: new Date() }));
    };

    const editButton = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center" justifyContent="center">
                <SquareButton
                    style={{
                        backgroundColor: '#183B68',
                        borderRadius: '20%',
                        width: '32px',
                        height: '32px',
                        textAlign: 'center',
                        padding: '0px 0px 0px 0px'
                    }}
                    onClick={() => handleUpdate(record)}
                >
                    <EditIcon fontSize="small" style={{ color: 'white' }} />
                </SquareButton>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        let newColumn = [...base_columns];
        let actionCol = newColumn.find((item) => item.field === 'action');
        if (actionCol) {
            actionCol.renderer = editButton;
        }
        return newColumn;
    }, []);

    const handleUpdate = (params) => {
        setState((state) => ({ ...state, subCategoryId: params?.vmrsSubCategoryID, modalToggle: true }));
    };

    const addButton = (gridRef, valueList) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="center" style={{ paddingRight: '7px' }}>
                <SquareButton
                    style={{
                        backgroundColor: '#183B68',
                        borderRadius: '20%',
                        width: '32px',
                        height: '32px',
                        textAlign: 'center',
                        padding: '0px 0px 0px 0px',
                        marginLeft: '20px'
                    }}
                    onClick={() => handleUpdate()}
                >
                    <AddIcon fontSize="small" style={{ color: 'white' }} />
                </SquareButton>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const closeModalHandler = (res) => {
        setState((state) => ({ ...state, modalToggle: false }));
        res && pullVmrsSubCategory();
    };

    const title = state.subCategoryId ? 'Update VMRS Sub Category' : 'Add VMRS Sub Category';

    return (
        <div className="report-screen-container">
            <BreadCrumbs crumbs={crumbs} />

            <ReportGijgoGrid
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                columns={columns}
                getUrl={'VMRSSubCategory'}
                AddBtn={addButton}
                isReload={state.isReload}
            />
            {state.modalToggle ? (
                <DialogComp title={title} onClose={() => closeModalHandler(false)}>
                    <AddEditVmrsModal subCategoryId={state.subCategoryId} onClose={() => closeModalHandler(true)} />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default VmrsSubCategoryScreen;
